module.exports = {
  sanitizePath(srcpath) {
    return srcpath.replace(/\\/g, '/').replace(/\/{2,}/g, '/')
  }
}
